var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineDownSmooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 2C3.03486 2 3.33333 2.29848 3.33333 2.66667V11.3333C3.33333 12.0697 3.93029 12.6667 4.66667 12.6667H13.3333C13.7015 12.6667 14 12.9651 14 13.3333C14 13.7015 13.7015 14 13.3333 14H4.66667C3.19391 14 2 12.8061 2 11.3333V2.66667C2 2.29848 2.29848 2 2.66667 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5437 11.2991C13.893 11.1827 14.0818 10.8051 13.9653 10.4558L12.6475 6.50251C12.1774 5.09205 10.3873 4.66946 9.33596 5.72076L8.38696 6.66976C8.03652 7.0202 7.43981 6.87933 7.2831 6.40918L5.96532 2.45585C5.84889 2.10655 5.47134 1.91778 5.12204 2.03421C4.77275 2.15064 4.58398 2.52819 4.70041 2.87748L6.01819 6.83081C6.48834 8.24128 8.27846 8.66387 9.32976 7.61257L10.2788 6.66357C10.6292 6.31313 11.2259 6.454 11.3826 6.92415L12.7004 10.8775C12.8168 11.2268 13.1944 11.4156 13.5437 11.2991Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDownSmooth);
export default __webpack_public_path__ + "static/media/line-down-smooth.cdca721972a87744f6e3b6c7291aa7e6.svg";
export { ForwardRef as ReactComponent };